<template>
    <div class="containers">
        <div v-if="!flagSetting">
            <div class="search-area">
                <CAlert
                v-if="success == true"
                :show.sync="currentAlertCounter"
                closeButton
                style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
                >
                {{alertMess}}
                </CAlert>
                <CAlert
                v-else
                :show.sync="currentAlertCounter"
                closeButton
                style="background-color:red;border-radius:0;text-align:center;color:white"
                >
                {{alertMess}}
                </CAlert>
                <CRow class="no-gutters">
                    <CCol style="padding-right:4px" sm="5">
                        <input type="text" v-model="searchName" placeholder="Nama Pegawai" class="form-control"/>
                    </CCol>
                    <CCol style="padding-right:4px;padding-left:4px" sm="5">
                        <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataPJTK" class="form-control" v-model="pjtk" placeholder="Pilih PJTK"></model-select>
                    </CCol>
                    <CCol style="padding-left:6px" sm="2">
                        <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                    </CCol>
                </CRow>
            </div>
            <div class="sticky1">
                <CRow>
                    <CCol sm="2" style="float:left">
                        <CButton @click="importModal = true" type="button" class="btn btn-add">Import</CButton>
                    </CCol>
                    <CCol sm="4" style="float:left">
                        <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                        <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                        <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
                    </CCol>
                    <CCol sm="6">
                        <span style="float:right">
                            <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                            <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        </span>
                        <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                        <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                        <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    </CCol>
                </CRow>
            </div>
            <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
            <CModal
                size="xl"
                :centered="true"
                color="white"
                :show.sync="importModal"
                :closeOnBackdrop="false"
                >
                <template #header-wrapper>
                    <div class="headers-modal">
                        <CRow>
                            <CCol sm="10">
                                <div>Import Excel Harga Satuan TAD</div>
                            </CCol>
                            <CCol sm="2" class="text-right">
                                <img :src="closeIcon" @click="importModal = false" style="cursor:pointer" width="20px" height="20px"/>
                            </CCol>
                        </CRow>
                    </div>
                </template>
                <template #body-wrapper>
                    <div style="padding:24px">
                        <CRow>
                            <CCol sm="6">
                                <label>Unduh Template Excel Harga Satuan</label>
                                <div>
                                    <CButton style="width:200px" @click="getDownloadTemplate()" color="primary" variant='outline'><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'download'}" />Export Template</CButton>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <label>Import Harga Satuan (.xls)</label>
                                <div>
                                    <CButton style="width:200px" color="primary" onclick="document.getElementById('inputFile').click()" variant='outline'>
                                        <span v-if="loadingUpload == false"><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'upload'}" />Import Excel</span>
                                        <CSpinner v-else color="default" size="sm"/>
                                    </CButton>
                                    <input type="file" @change="loadFile()" style="display:none" accept=".xls, .xlsx" id="inputFile" class="hide" />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow style="padding:16px" class="mt-4">
                            <CRow v-if="dataImport != [] && dataImport.data != undefined">
                                <CCol sm="4">
                                    Total data yang berhasil terbaca
                                </CCol>
                                <CCol sm="8">
                                    : <span class="font-weight-bold">{{dataImport.data.length}} Data</span>
                                </CCol>
                                <CCol sm="4">
                                    Total data yang sukses
                                </CCol>
                                <CCol sm="8">
                                    : <span class="font-weight-bold">{{importValid}} Data</span>
                                </CCol>
                                <CCol sm="4">
                                    Total data yang tidak ditemukan
                                </CCol>
                                <CCol sm="8">
                                    : <span class="font-weight-bold">{{importInvalid}} Data</span>
                                </CCol>
                                <CCol sm="4">
                                    Export Result Review
                                </CCol>
                                <CCol sm="8">
                                    : <img @click="getDownloadReview()" style="cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                                </CCol>
                            </CRow>
                            <div v-if="dataImport != ''" class="mt-1" style="overflow-x:auto;">
                                <table>
                                    <thead>
                                        <tr>
                                            <th v-for="(head, id) in dataImport.kolom" :key="id">{{head}}</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="dataImport.data.length != 0">
                                        <tr v-for="(row, ids) in dataImport.data" :key="ids">
                                            <td v-for="(col, index) in row" :key="index">{{col}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr >
                                            <td class="text-center" :colspan="dataImport.kolom.length">Maaf, Data Excel Kosong</td>
                                        </tr>
                                    </tbody>     
                                </table>
                            </div>
                        </CRow>
                        <CRow class="area-button-submit" v-if="dataImport != [] && dataImport.data != undefined">
                            <CCol sm="12">
                                <CButton @click="importModal = false" type="button" style="float:left" class="btn btn-cancel mr-2">Batal</CButton>
                                <CButton v-if="dataImport.data.length != 0" @click="sumbitImport()" class="btn btn-edit-submit">
                                    <span v-if="loadingImport == false">Submit</span>
                                    <CSpinner v-else color="default" size="sm"/>
                                </CButton>
                            </CCol>
                        </CRow>
                    </div>
                </template>
                <template #footer-wrapper><span></span></template>
            </CModal>
        </div>
        <div v-if="flagSetting">
            <SettingKontrak :isDetail="flagSetting" :isData="datasDetail" @goDetail="checkDetail" @goUpdate="checkUpdate"/>
        </div>
    </div>
    </template>
    
    <script>
    import Tables from '../../../component/tableKontrakPegawai'
    import {DataApi} from "../../../service/DataApi";
    import { ModelSelect } from 'vue-search-select'
    import SettingKontrak from './SettingKontrakPegawai.vue'
    
    const xlsx = require('json-as-xlsx')
    
    export default {
        components: {
            ModelSelect,
            Tables,
            SettingKontrak
        },
        data() {
            return {
                importModal: false,
                infoImport: '',
                dataImport: [],
                importInvalid: '',
                filesImport: '',
                importValid: '',
                loadingUpload: false,
                loadingImport: false,
                
                
                flagSetting: false,
                datasDetail: [],
                // data search pegawai
                dataPJTK: [],
                pjtk: {
                    text: '',
                    value: ''
                },
    
                // datas
                refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
                downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
                closeIcon: require('../../../assets/menu/icon_close.svg'),
                moreIcon: require('../../../assets/menu/icon_more.svg'),
                dataTh: ['Nama / NIP', 'Bidang / Jabatan', 'Kontrak', 'PJTK', 'Tanggal Kontrak', 'Diperbaharui', 'Harga', 'Status'],
                dataTd: [['nama', 'nik'], ['bidang', 'jabatan'], ['nomorKontrak', 'namaKontrak'], 'organisasiPJTK', ['tanggalMulaiKontrak', 'tanggalAkhirKontrak'], 'modified', 'hargaSatuan', 'statusPengadaan' ],
                styleTable: ['100px', '125px', '100px', '100px', '100px', '75px', '75px', '75px'],
                classReload: 'reloadOff',
                datas: [],
    
                // paging
                page: 1,
                size: 20,
                totalRow: 0,
                totalPage: 1,
                firstPage: 0,
                lastPage: 0,
    
                // filter
                searchName: '',
    
                // error
                errorMessage: '',
                flagSearch: false,
    
                alertMess: '',
                currentAlertCounter: 0,
                success: true,
            }
        },
        computed: {
        },
        watch: {
            page() {
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            searchName() {
                this.flagSearch = true
            },
            queryPJTK() {
                this.flagSearch = true
            },
            importModal() {
                if(this.importModal == false) {
                    this.dataImport = []
                    this.importInvalid = ''
                    this.importValid = ''
                    document.getElementById('inputFile').value= null;
                }
            }
        },
        methods: {
            checkDetail(value) {
                if(!value) {
                    this.flagSetting = false
                    this.datasDetail = []
                }
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            checkUpdate(value) {
                this.flagSetting = false
                this.datasDetail = []
                this.alertMess = value.resp
                this.currentAlertCounter = 5
                this.success = value.suc
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
                this.getData()
            },
            /**
             * SEARCH PJTK
             */
            getDataPJTK() {
                let payload = {
                    limit: 9999,
                    namaOrganisasi: '',
                    organisasi: '',
                    pageIn: 1,
                    pjtk: 'Y'
                }
                DataApi.post("perusahaan/get", payload)
                .then(res => {
                    this.dataPJTK = [
                        {
                            text: 'Semua PJTK',
                            value: ''
                        }
                    ]
                    let response = res.data
                    let tempData = response.data.data
                    var i = 0;
                    for(i=0;i<tempData.length;i++) {
                        let onPush = {
                            value: tempData[i].kode,
                            text: tempData[i].nama
                        }
                        this.dataPJTK.push(onPush)
                    }
                })
            },
            
    
            sorting(value) {
                if(value == 0) {
                    function compare(a,b) {
                        if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                            return -1
                        }
                        if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 1) {
                    function compare(a,b) {
                        if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                            return -1
                        }
                        if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 2) {
                    function compare(a,b) {
                        if (a.polaAbsensi.toLowerCase() < b.polaAbsensi.toLowerCase()) {
                            return -1
                        }
                        if (a.polaAbsensi.toLowerCase() > b.polaAbsensi.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 3) {
                    function compare(a,b) {
                        if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                            return -1
                        }
                        if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 4) {
                    function compare(a,b) {
                        if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                            return -1
                        }
                        if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 5) {
                    function compare(a,b) {
                        if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                            return -1
                        }
                        if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 6) {
                    function compare(a,b) {
                        if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                            return -1
                        }
                        if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 7) {
                    function compare(a,b) {
                        if (a.cuti.toLowerCase() < b.cuti.toLowerCase()) {
                            return -1
                        }
                        if (a.cuti.toLowerCase() > b.cuti.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 8) {
                    function compare(a,b) {
                        if (a.sakit.toLowerCase() < b.sakit.toLowerCase()) {
                            return -1
                        }
                        if (a.sakit.toLowerCase() > b.sakit.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 9) {
                    function compare(a,b) {
                        if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                            return -1
                        }
                        if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 10) {
                    function compare(a,b) {
                        if (a.nsi.toLowerCase() < b.nsi.toLowerCase()) {
                            return -1
                        }
                        if (a.nsi.toLowerCase() > b.nsi.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 11) {
                    function compare(a,b) {
                        if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                            return -1
                        }
                        if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 12) {
                    function compare(a,b) {
                        if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                            return -1
                        }
                        if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 13) {
                    function compare(a,b) {
                        if (a.cepet.toLowerCase() < b.cepet.toLowerCase()) {
                            return -1
                        }
                        if (a.cepet.toLowerCase() > b.cepet.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 14) {
                    function compare(a,b) {
                        if (a.lembur.toLowerCase() < b.lembur.toLowerCase()) {
                            return -1
                        }
                        if (a.lembur.toLowerCase() > b.lembur.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 15) {
                    function compare(a,b) {
                        if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                            return -1
                        }
                        if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 16) {
                    function compare(a,b) {
                        if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                            return -1
                        }
                        if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                }
            },
            getDownload() {
                this.$store.state.loadingScreen = true
                let payload = {
                    idPegawai: this.idPegawai,
                    limit: this.totalRow,
                    lvl: this.idUnits,
                    namaKontrak: this.searchKontrak,
                    pageIn: 1,
                    tanggalMulai: this.tanggalMulai,
                    tanggalSelesai: this.tanggalBerakhir
                }
                DataApi.post("pegawai/kontrak/lihat", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        let downloads = response.data.data
                        let fileName = 'Daftar Kontrak Pegawai'
                        let data = [
                            {
                                sheet: fileName,
                                columns: [
                                    { label: 'Nama', value: 'idPegawai'  },
                                    { label: 'NIP', value: 'nik' },
                                    { label: 'Jabatan', value: 'jabatan' },
                                    { label: 'Bidang', value: 'bidang' },
                                    { label: 'Judul Kontrak', value: 'judulKontrak' },
                                    { label: 'Penempatan Wilayah', value: 'penemparanWilayah' },
                                    { label: 'Nama Kontrak Pihak 1', value: 'namaKontrakPihak1'},
                                    { label: 'Nomor Kontrak Pihak 1', value: 'nomorKontrakPihak1'},
                                    { label: 'Tanggal Mulai Kontrak Pihak 1', value: 'tanggalMulaiKontrakPihak1'},
                                    { label: 'Tanggal Berakhir Kontrak Pihak 1', value: 'tanggalSelesaiKontrakPihak1'},
                                    { label: 'Nama Kontrak Pihak 2', value: 'namaKontrakPihak2'},
                                    { label: 'Nomor Kontrak Pihak 2', value: 'nomorKontrakPihak2'},
                                    { label: 'Tanggal Mulai Kontrak Pihak 2', value: 'tanggalMulaiKontrakPihak2'},
                                    { label: 'Tanggal Berakhir Kontrak Pihak 2', value: 'tanggalSelesaiKontrakPihak2'},
                                ],
                                content: downloads
                            }
                        ]
                        let settings = {
                            fileName: fileName
                        }
                        xlsx(data, settings)
                    }
                    this.$store.state.loadingScreen = false
                })
            },
            getData() {
                this.flagSearch ? this.page = 1 : ''
                let payload = {
                    nama: this.searchName,
                    organisasi: this.pjtk.value,
                    limit: this.size,
                    pageIn: this.page
                }
                DataApi.post("pegawai_kontrak/get", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.datas = response.data.data
                        this.totalRow = response.data.totalRow
                        this.firstPage = (((this.page - 1) * this.size) + 1 )
                        this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                        this.totalPage = Math.floor(this.totalRow/this.size)
                        let modAr = this.totalRow%this.size
                        if(modAr != 0) {
                            this.totalPage = this.totalPage + 1
                        } else {
                            //
                        }
                    } else {
                        this.datas = []
                        this.errorMessage = response.message
                        this.firstPage = 0
                        this.lastPage = 0
                        this.totalRow = 0
                        this.totalPage = 1
                    }
                    this.flagSearch = false
                    this.$store.state.loadingScreen = false
                })
            },
    
            editData(value) {
                this.flagSetting = true
                this.datasDetail.push(this.datas[value])
            },
            findData() {
                this.getData()
            },
            reload() {
                this.queryPJTK = ''
                this.pjtk.text = ''
                this.pjtk.value = ''
                this.getDataPJTK()
                this.flagSearch = true
                this.getData()
                if (this.classReload == 'reloadOff') {
                    this.classReload = 'reloadOn'
                } else {
                    this.classReload = 'reloadOff'
                }
            },
            movePage(direction) {
                if(direction == 'prev') {
                    this.page = this.page -  1
                } else {
                    this.page = this.page +  1
                }
                this.getData()
            },
            validatePage(page) {
                if(page > this.totalPage) {
                    this.page = this.totalPage
                }
            },
            getDownloadTemplate() {
                let payload = {}
                DataApi.post("/export/pegawai_kontrak/import/template", payload, {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Template Harga Satuan')
                    document.body.appendChild(link)
                    link.click()
                })
            },
            loadFile() {
                this.loadingUpload = true
                let nama = document.getElementById('inputFile').files[0]

                this.dataImport = []
                this.filesImport = document.getElementById('inputFile').files[0];

                const formData = new FormData();
                formData.append("file", this.filesImport)
                DataApi.post("import/pegawai_kontrak/preview", formData)
                .then(res => {
                    let temp = res.data
                    if(temp.success == true) {
                        this.dataImport = temp.data
                        this.importInvalid = temp.data.jumlahInvalid
                        this.importValid = temp.data.jumlahValid
                        this.infoImport = nama.name
                    } else {
                        this.dataImport = []
                        this.importInvalid = ''
                        this.importValid = ''
                        this.alertMessImport = temp.message
                        this.currentAlertCounterImport = 7
                        this.successImport = false
                        window.scroll({
                            top:0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                    this.loadingUpload = false
                })
            },
            getDownloadReview() {
                let payload = {
                    jumlahInvalid: this.importInvalid,
                    jumlahValid: this.importValid,
                    kolom: this.dataImport.kolom,
                    data: this.dataImport.data,
                }
                DataApi.post("/export/pegawai_kontrak/preview/import", payload, {responseType: 'blob'})
                    .then(res => {
                        let response = res.data
                        // let fileName = res.headers["content-disposition"].split("filename=")[1];
                        const url = URL.createObjectURL(new Blob([response], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'Import Review Harga Satuan')
                        document.body.appendChild(link)
                        link.click()
                    })
            },
            sumbitImport() {
                this.loadingImport = true
                let payload = this.dataImport.data
                DataApi.post("import/pegawai_kontrak", payload )
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        if(response.data.Data1 == 'Y') {
                            this.success = true
                        } else {
                            this.success = false
                        }
                        this.alertMess = response.data.Data2
                    } else {
                        this.alertMess = response.message
                        this.success = false
                    }
                    this.getData()
                    this.currentAlertCounter = 7
                    this.loadingImport = false
                    this.importModal = false
                })
            }
        },
        mounted() {
            this.errorMessage = 'Find Your Data'
            this.getDataPJTK()
        }
    }
    </script>
    <style scoped>
    .autocomplete {
        width: 100%;
        position: relative;
    }
    .input {
        cursor: text;
    }
    .close {
        position: absolute;
        right: 8px;
        top: 10px;
        background: none;
        border: none;
        font-size: 14px;
        color: lightgrey;
        cursor: pointer;
    }
    .placeholder {
        position: absolute;
        top: 7px;
        left: 16px;
        font-size: 14px;
        color: #d0d0d0;
    }
    .popovers {
        text-align: center;
        width: 100% !important;
        min-height: 50px;
        border: 1px solid #d8dbe0;
        position: absolute;
        top: 35px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 8px;
        left: 0;
        right: 0;
        background: #fff;
        border-radius: 3px;
        text-align: center;
        z-index: 3;
    }
    .popovers input {
        right: 8px;
        left: 8px;
        width: 100%;
    }
    .options {
        max-height: 200px;
        overflow-y: auto;
        margin-top: 5px;
    }
    .options ul {
        list-style-type: none;
        text-align: left;
        padding-left: 0;
    }
    .options ul li {
        border-bottom: 1px solid lightgrey;
        padding: 10px;
        cursor: pointer;
        background: white;
    }
    .options ul li:first-child {
        border-top: 1px solid lightgray;
    }
    .options ul li:not(.selected):hover {
        background: whitesmoke;
        color: rgba(16, 16, 16, 1);
    }
    .options ul li.selected {
        background: whitesmoke;
        color: rgba(16, 16, 16, 1);
    }
    .nowraps {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .card-title {
        font-size: 14px;
        font-weight: 600;
        color: rgba(16, 16, 16, 1);
    }
    .card-subtitle {
        font-size: 12px;
        color: rgba(154, 154, 154, 1);
    }
    .card-emblem {
        float:right;
        background-color:rgba(48, 107, 221, 0.05);
        text-align: center;
        line-height: 32px;
        min-width:40px;
        min-height:40px;
        border-radius:50%;
    }
    input[type="checkbox"] {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .containers {
        background-color: white;
        border-bottom: 1px solid #e5e6e8;
    }
    .btn-search {
        border-radius: 4px;
        float: right;
        width: 100%;
        background-color:rgba(48, 107, 221, 1);
        color: white;
    }
    .btn-search:hover {
        border-radius: 4px;
        float: right;
        width: 100%;
        background-color:rgba(48, 107, 255, 1);
        color: white;
    }
    .reloadOn {
        float: left;
        cursor: pointer;
        transform: rotate(360deg);
        transition: 300ms linear all;
    }
    .reloadOff {
        float: left;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 300ms linear all;
    }
    div.search-area {
        padding-top: 12px;
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 12px !important;
        background-color: white;
        z-index: 1;
    }
    div.sticky1 {
        position: -webkit-sticky;
        position: sticky;
        top: 54px;
        padding-top: 12px;
        padding-right: 24px;
        padding-left: 24px;
        padding-bottom: 12px !important;
        background-color: white;
        z-index: 1;
    }
    input {
        background-color: rgba(249, 250, 252, 1);
    }
    .btn-add {
        border-radius: 4px;
        width: 100%;
        margin-right: 6px;
        border: 1px solid green;
        background-color:white;
        color: rgba(16, 16, 16, 1);
        font-weight: 500;
        font-size: 14px;
    }
    .btn-add:hover {
        border-radius: 4px;
        width: 100%;
        margin-right: 6px;
        border: 1px solid green;
        background-color: green;
        color: white;
    }
    ::v-deep .month-picker__container {
        z-index: 5 !important;
        width: 250px;
    }
    ::v-deep .month-picker__year button {
        width: 50px;
        height: 48px;
    }
    ::v-deep .month-picker-input {
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: .875rem;
        font-weight: 400;
        line-height: 1.5;
        background-clip: padding-box;
        border: 1px solid;
        color: #768192;
        border-color: #d8dbe0;
        background-color: #f9fafc;
        border-radius: .25rem;
    }
    ::v-deep .month-picker-input-container {
        width: 100%;
        min-width: none;
    }

    ::v-deep .modal-header {
    border-bottom: none !important;
    }
    .headers-modal {
        padding-top: 32px;
        padding-bottom: 32px;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 18px;
        font-weight: bold;
        color: rgba(16, 16, 16, 1);
    }
    .modal-buttons {
        width:156px;
        height: 36px;
    }
    table {
        width: 100%;
    }
    table thead tr {
        background-color: rgba(244, 244, 244, 1);
    }
    thead th {
        padding-top: 12px;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 12px;
    }
    tbody td {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 10px;
        padding-right: 10px;
    }
    td,th {
        /* overflow-x: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap; */
        border: 1px solid rgba(238, 238, 238, 1);
        font-size: 14px;
    }
    tr:nth-child(even) {
        background-color: rgba(252, 252, 252, 1);
    }
    .area-button-submit {
        padding-left: 20px;
        padding-bottom: 20px;
        padding-top: 32px;
    }
    .btn-edit-submit {
        border-radius: 4px;
        float: left;
        width: 200px;
        background-color:rgba(48, 107, 221, 1);
        color: white;
        font-size: 14px;
    }
    .btn-cancel {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
    .btn-cancel:hover {
        border-radius: 4px;
        width: 200px;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color: rgba(48, 107, 221, 1);
        color: white;
    }
</style>